import { AfterViewInit, Component, effect, inject, input, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { GridStackOptions } from 'gridstack';
import { GridstackItemComponent, GridstackModule, nodesCB } from 'gridstack/dist/angular';

import { FIELD_ICONS, FieldTypesEnum, GRIDSTACK_CONSTANTS } from '@module-instance/form-builder-modal/common';
import { AddEditFieldComponent } from '@module-instance/form-builder-modal/form-builder/add-edit-field/add-edit-field.component';
import { FieldCardComponent } from '@module-instance/form-builder-modal/form-builder/field-card/field-card.component';
import { GridsterItemComponent } from '@module-instance/form-builder-modal/form-builder/gridster-item/gridster-item.component';
import { CipoFormModule } from '@shared/modules';
import { UserService } from '@shared/services';

@Component({
  selector: 'app-form-builder',
  imports: [GridstackModule, GridsterItemComponent, CipoFormModule, MatMenuModule, FieldCardComponent],
  templateUrl: './form-builder.component.html',
  styleUrl: './form-builder.component.scss',
})
export class FormBuilderComponent implements AfterViewInit {
  dialog = inject(MatDialog);
  userService = inject(UserService);
  FIELD_TYPES = FieldTypesEnum;
  FIELD_ICONS = FIELD_ICONS;
  gridOptions: GridStackOptions = {
    float: true,
    cellHeight: GRIDSTACK_CONSTANTS.cellHeight * 0.75,
    margin: GRIDSTACK_CONSTANTS.margin,
  };
  viewInitialized = signal(false);

  fields = input<GridstackItemComponent[]>([]);
  searchCriteria = signal('');
  showContractFields = signal(false);

  constructor() {
    effect(() => {
      console.log('searchCriteria', this.searchCriteria());
    });
    effect(() => console.log('showContractFields', this.showContractFields()));
  }

  ngAfterViewInit(): void {
    this.viewInitialized.set(true);
  }

  onChange(event: nodesCB) {
    console.log(event.nodes);
  }

  addNewField(type: FieldTypesEnum) {
    this.dialog.open(AddEditFieldComponent, {
      panelClass: ['cipo-dialog', 'classic', 'cipo--height--full'],
      ...this.userService.getResponsiveDialogSize().md,
      data: type,
    });
  }
}
